import { styled } from '@linaria/react';

import { textColourForBackground } from '../../../utils/textColourForBackground';

import Cta from './Cta';
import Text from './Text';

export const CardContent = styled.div`
  min-height: 100%;
  min-width: 100%;
`;

const HeadingStyles = `
	font-size: var(--heading-font-size);
	font-weight: 700;
	margin-top: 4px;
`;

export const Heading = styled.div`
  ${HeadingStyles}
`;

export const LogoContainer = styled.div`
  display: flex;
  column-gap: 0.4em;
  align-items: center;

  & > img {
    height: var(--offer-bookmaker-logo-height);
    width: var(--offer-bookmaker-logo-width);
  }

  & > span {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
    font-size: 0.6rem;
    height: fit-content;
    padding: 2px 6px;
  }
`;

const Card = styled.div<{ color: string }>`
  background-color: ${p => p.color};
  color: ${p => (textColourForBackground(p.color) === 'light' ? 'white' : 'black')};
  border-radius: var(--offer-border-radius);
  padding: 0.5em 1em;
  cursor: default;

  --heading-font-size: 1.2em;
`;

export const DefaultCard = styled(Card)`
  ${CardContent} {
    display: grid;
    gap: 0.6em;
    grid-template-columns: 1fr minmax(82px, max-content);
    grid-template-areas:
      'logo logo'
      'heading cta'
      'text text';
  }

  ${Heading} {
    grid-area: heading;
    align-self: center;

    svg {
      display: none;
    }
  }

  ${Cta} {
    grid-area: cta;
    align-self: center;
  }

  ${LogoContainer} {
    grid-area: logo;
  }

  ${Text} {
    grid-area: text;
    align-self: end;
  }
`;

export const AutohideCard = styled(Card)`
  --heading-font-size: 0.875em;
  position: relative;

  ${Text} {
    max-height: 500px;
  }

  ${Cta} {
    max-height: 150px;
  }

  ${Heading} {
    svg {
      display: inline-block;
      margin-left: 0.2em;
      position: relative;
      top: 1px;
    }
  }

  ${CardContent} {
    background-color: inherit;
    position: absolute;
    padding: inherit;
    border-radius: inherit;
    bottom: 0;
    left: 0;
  }

  ${Text}, ${Cta} {
    overflow: hidden;
    transition-delay: 0;
    transition: all 690ms ease;
  }

  &:before {
    content: attr(data-height);
    display: block;
    padding-top: var(--offer-bookmaker-logo-height);
    ${HeadingStyles}
    visibility: hidden;
  }

  &:hover {
    ${Text}, ${Cta} {
      transition-delay: 400ms;
    }
  }

  &:not(:hover) {
    ${Text}, ${Cta} {
      max-height: 0;
    }
  }

  &:has(${LogoContainer} > label) {
    min-width: 210px;
  }
`;

export default Card;
